const map = {
	"./2023-09-19-SDO-Sun.png": 4974,
	"./HighwayGothicNarrow.ttf": 3047,
	"./annular.png": 8157,
	"./center": 2560,
	"./center.json": 2560,
	"./center_lo": 3084,
	"./center_lo.json": 3084,
	"./cloud_cover.csv": 1094,
	"./eclipse.gif": 9442,
	"./eclipse_static.gif": 435,
	"./eclipseds.png": 1834,
	"./empty.png": 6661,
	"./giphy.webp": 6256,
	"./lo_res_2026.zip": 6104,
	"./moon-dark-gray-overlay.png": 959,
	"./moon-sky-blue-overlay-10.png": 1895,
	"./moon-sky-blue-overlay-100.png": 6663,
	"./moon-sky-blue-overlay-20.png": 8342,
	"./moon-sky-blue-overlay-50.png": 6091,
	"./moon.png": 2783,
	"./new-rectangle-solid-svgrepo-com.svg": 3243,
	"./none.png": 5422,
	"./output.zip": 3354,
	"./partial.png": 6241,
	"./total.png": 296,
	"./upath_lo": 9233,
	"./upath_lo.json": 9233
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;